class StickyButton extends HTMLElement {
    constructor() {
      super();
      this.buttonContainer = null;
      this.isInViewport = true;
      this.onScrollHandler = this.onScroll.bind(this);
    }
  
    connectedCallback() {
      this.initializeDOMElements();
      this.addEventListeners();
      this.createObserver();
    }
  
    disconnectedCallback() {
      this.removeEventListeners();
    }
  
    initializeDOMElements() {
        this.buttonContainer = this;
    }
  
    addEventListeners() {
      window.addEventListener('scroll', this.onScrollHandler);
    }
  
    removeEventListeners() {
      window.removeEventListener('scroll', this.onScrollHandler);
    }
  
    createObserver() {
      const observer = new IntersectionObserver((entries) => {
        this.isInViewport = entries[0].isIntersecting;
      });
  
      observer.observe(this.buttonContainer);
    }
  
    onScroll() {
      if (!this.isInViewport) {
        // Button container is not in the viewport
        this.classList.add('button-sticky');
      } else {
        // Button container is in the viewport
        this.classList.remove('button-sticky');
      }
    }
  }
  
  customElements.define('sticky-button', StickyButton);
  